var map = {
	"./amdaris.png": 592,
	"./golfbreaks.png": 73839,
	"./gusborne.png": 15052,
	"./signal.png": 78079,
	"./sonder.png": 26862,
	"./stance.png": 51339,
	"./stewart.png": 35795,
	"./taylormade.png": 17005,
	"./virgin.png": 84828,
	"./vivir.png": 79349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36768;